import React, { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

export const DescargarApp = () => {
  const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  };

  const getCookie = (name) => {
    const cookieArr = document.cookie.split(';');
    for (let i = 0; i < cookieArr.length; i++) {
      const cookiePair = cookieArr[i].trim().split('=');
      if (cookiePair[0] === name) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  };

  function esAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  function esIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }

  function esSafariOChrome() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
  }

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('App') === '1') {
        if (esAndroid()) {
          window.location.href = "market://details?id=app.SIsGes";
        } else if (esIOS()) {
          if (esSafariOChrome()) {
            localStorage.clear()
            var variable = 1;
            setCookie('Descarga', variable, 30);
            window.location.href = "/";
          }
        } else {
          window.location.href = "/";
        }
      } else {
        var valorCookie = getCookie('Descarga');
        if (valorCookie == "1") {
          function miFuncion() {
            const script = document.createElement('script');
            script.src = '/js/Descargar.js';
            script.async = true;
            document.body.appendChild(script);
            var variable = 0;
            setCookie('Descarga', variable, 30);
          }
          // Agregar el CSS
          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = "/dist/add-to-homescreen.min.css";
          document.head.appendChild(link);

          // Agregar el JS
          const script = document.createElement("script");
          script.type = "text/javascript";
          script.src = "/dist/add-to-homescreen.min.js";
          script.defer = true;
          document.body.appendChild(script);
          setTimeout(miFuncion, 50); // Ejecuta miFuncion cada 2000 milisegundos (2 segundos)

        }
      }
    }
  }, []);
  return (
    <div>
    </div>
  )
}